import React, { useEffect, useState } from 'react';
import '../../Static/priceinfo.css';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from '@mui/material';

const StitchingItemView = () => {
    const [formData, setFormData] = useState([]);
    const isDesktop = useMediaQuery('(min-width:768px)');

    useEffect(() => {
        // Retrieve the URL parameters
        const query = new URLSearchParams(window.location.search);
        const formParam = query.get('form');

        if (formParam) {
            try {
                // Parse the form data
                const parsedForm = JSON.parse(decodeURIComponent(formParam));
                setFormData(parsedForm);
            } catch (error) {
                console.error('Error parsing form data:', error);
            }
        }
    }, []);


    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    console.log(formData);

    return (
        <>
            <div style={{ margin: '1% 0%', width: '100%' }}>
                <Paper style={{ padding: '2vh' }}>
                    <h3 className='centered-heading'>Stitching Item View</h3>
                    <div className="dashed-line"></div>

                    <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                        <tbody>

                            <tr>
                                <td style={{ width: '200px' }}>Item Name</td>
                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{formData.itemNm}</td>
                                <td style={{ width: '200px', paddingLeft: '2%' }}>Sale Order</td>
                                <td style={{ padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.sono}</td>
                            </tr>

                            <tr>
                                <td style={{ width: '200px' }}>Cutting Memo No.</td>
                                <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.cutMemo}</td>
                                <td style={{ width: '100px', paddingLeft: '2%' }}>Cutting Return Memo.</td>
                                <td style={{ width: '15vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.cutrememo}</td>
                            </tr>


                            <tr>
                                <td style={{ width: '200px' }}>Main Cloth</td>
                                <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.mclothNm}</td>
                                {formData.m1cloth !== '0' &&
                                    <>
                                        <td style={{ width: '200px' }}>M1 Cloth</td>
                                        <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.m1clothNm != 0 ? formData.m1clothNm : null}</td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {formData.m2cloth !== '0' &&
                                    <>
                                        <td style={{ width: '100px', paddingLeft: '2%' }}>M2 Cloth</td>
                                        <td style={{ width: '15vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.m2clothNm != 0 ? formData.m2clothNm : null}</td>
                                    </>
                                }
                                {formData.m3cloth !== '0' &&
                                    <>
                                        <td style={{ width: '200px' }}>M3 Cloth</td>
                                        <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.m3clothNm != 0 ? formData.m3clothNm : null}</td>
                                    </>
                                }

                            </tr>
                            <tr>
                                <td style={{ width: '200px', paddingLeft: '2%' }}>Total Qty.</td>
                                <td style={{ padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.totqty}</td>
                            </tr>
                        </tbody>

                    </table>


                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '100px' }} align='center' className='tbl-row'>Size</TableCell>
                                    {formData?.itemSize?.map((val, index) => (
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val.size}</TableCell>
                                    ))}
                                </TableRow>

                                {/* {formData.ordType === '2' &&
                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '100px' }} align='center' className='tbl-row'>Fusion Qty.</TableCell>
                                        {formData?.fqty?.map((val, index) => (
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                        ))}
                                    </TableRow>}

                                {formData.ordType !== '2' &&
                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '100px' }} align='center' className='tbl-row'>Cutting Qty.</TableCell>
                                        {formData?.ctqty?.map((val, index) => (
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                        ))}
                                    </TableRow>} */}

                                <TableRow>
                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '100px' }} align='center' className='tbl-row'>Qty.</TableCell>
                                    {formData?.itemSize?.map((val, index) => (
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val.rbqty}</TableCell>
                                    ))}
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '100px' }} align='center' className='tbl-row'>Issue Qty.</TableCell>
                                    {formData?.itemSize?.map((val, index) => (
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                            {formData?.issqty[index] || '0'}
                                        </TableCell>
                                    ))}
                                </TableRow>
                                 <TableRow>
                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '100px' }} align='center' className='tbl-row'>Extra Qty.</TableCell>
                                    {formData?.itemSize?.map((val, index) => (
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                            {formData?.extraqty[index] || '0'}
                                        </TableCell>
                                    ))}
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '100px' }} align='center' className='tbl-row'>Bal Qty.</TableCell>
                                    {formData?.itemSize?.map((val, index) => (
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                            {formData?.balqty[index] || '0'}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>


                    {/* <table style={{ width: '100%' }}>
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Material Work</th>
                                <th>Qty</th>
                            </tr>
                        </thead>
                        <tbody>
                            {formData?.materials?.map((mat, matIndex) => (
                                <>
                                    <tr key={matIndex}>
                                        <td>
                                            {matIndex + 1}
                                        </td>
                                        <td>
                                            {mat.materialNm}
                                        </td>
                                        <td>
                                            {mat.qty}
                                        </td>
                                    </tr>
                                </>
                            ))}
                            <tr>
                                <td> </td>
                                <td>
                                    <span className="tot-lump">Total Qty</span>
                                </td>
                                <td>
                                    <span className="tot-lump">{formData.totmat}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table> */}

                </Paper>
            </div>
        </>
    );
};

export default StitchingItemView;
